import React from "react";
import { Row, Col, Form } from "react-bootstrap";
import IE from "../../../../components/Formatters/IE";
import CNPJ from "../../../../components/Formatters/CNPJ";

const DadosGeraisCard = ({ dadosContribuinte }) => (
  <div className="col-lg-12">
    <div className="card shadow mb-1">
      <div className="card-header">
        <b>Dados Gerais</b>
      </div>
      <div className="card-body">
        <Row>
          <div className="col-sm-12">
            <Row>
              <Form.Group as={Col} md={8}>
                <Row>
                  <Form.Group as={Col} md={6}>
                    <div className="form-inline">
                      <Form.Label>
                        <b>Inscrição Estadual</b>
                      </Form.Label>{" "}
                      <br />
                    </div>
                    <div className="form-inline">
                      <Form.Label>
                        <IE value={dadosContribuinte?.inscricaoEstadual} />
                      </Form.Label>
                    </div>
                  </Form.Group>
                  <Form.Group as={Col} md={6}>
                    <div className="form-inline">
                      <Form.Label>
                        <b>CNPJ</b>
                      </Form.Label>
                    </div>
                    <div className="form-inline">
                      <Form.Label>
                        <CNPJ value={dadosContribuinte?.cnpjCnpf} />
                      </Form.Label>
                    </div>
                  </Form.Group>
                </Row>
                <Row>
                  <Form.Group as={Col} md={8}>
                    <div className="form-inline">
                      <Form.Label>
                        <b>CNAE Fiscal Primário</b>
                      </Form.Label>
                    </div>
                    <div className="form-inline">
                      <Form.Label>{dadosContribuinte?.cnaeFiscalPrimario}</Form.Label>
                    </div>
                  </Form.Group>
                </Row>
                <Row>
                  <Form.Group as={Col} md={8}>
                    <div className="form-inline">
                      <Form.Label>
                        <b>CNAE Fiscal Secundário</b>
                      </Form.Label>
                    </div>
                    <div className="form-inline">
                      <Form.Label>{dadosContribuinte?.cnaeFiscalSecundario}</Form.Label>
                    </div>
                  </Form.Group>
                </Row>
                <Row>
                  <Form.Group as={Col} md={4}>
                    <div className="form-inline">
                      <Form.Label>
                        <b>Regime Pagamento</b>
                      </Form.Label>{" "}
                      <br />
                    </div>
                    <div className="form-inline">
                      <Form.Label>{dadosContribuinte?.regimePagamento}</Form.Label>
                    </div>
                  </Form.Group>
                  <Form.Group as={Col} md={4}>
                    <div className="form-inline">
                      <Form.Label>
                        <b>Tipo Contribuinte</b>
                      </Form.Label>
                    </div>
                    <div className="form-inline">
                      <Form.Label>{dadosContribuinte?.tipoContribuinte}</Form.Label>
                    </div>
                  </Form.Group>
                  <Form.Group as={Col} md={4}>
                    <div className="form-inline">
                      <Form.Label>
                        <b>Início Atividade</b>
                      </Form.Label>
                    </div>
                    <div className="form-inline">
                      <Form.Label>{dadosContribuinte?.inicioAtividade}</Form.Label>
                    </div>
                  </Form.Group>
                </Row>
                <Row>
                  <Form.Group as={Col} md={12}>
                    <div className="form-inline">
                      <Form.Label>
                        <b>Endereço</b>
                      </Form.Label>
                    </div>
                    <div className="form-inline">
                      <Form.Label>{dadosContribuinte?.endereco}</Form.Label>
                    </div>
                  </Form.Group>
                </Row>
              </Form.Group>
              <Form.Group as={Col} md={4}>
                <div className="card shadow mb-1">
                  <div className="card-header">
                    <b>Situação</b>
                  </div>
                  <div className="card-body">
                    <Row>
                      <Form.Group as={Col} md={6}>
                        <div className="form-inline">
                          <Form.Label>
                            <b>Cadastral</b>
                          </Form.Label>{" "}
                          <br />
                        </div>
                        <div className="form-inline">
                          <Form.Label>{dadosContribuinte?.situacaoCadastral}</Form.Label>
                        </div>
                      </Form.Group>
                      <Form.Group as={Col} md={2}>
                        <div className="form-inline">
                          <Form.Label>
                            <b>Fiscal</b>
                          </Form.Label>
                        </div>
                        <div className="form-inline">
                          <Form.Label>{dadosContribuinte?.situacaoFiscal}</Form.Label>
                        </div>
                      </Form.Group>
                    </Row>
                    <Row>
                      <Form.Group as={Col} md={12}>
                        <div className="form-inline">
                          <Form.Label>
                            <b>
                              Credenciamento <small>(ICMS Antecipado)</small>
                            </b>
                          </Form.Label>
                        </div>
                        <div className="form-inline">
                          <Form.Label>{dadosContribuinte?.credenciamento}</Form.Label>
                        </div>
                      </Form.Group>
                    </Row>
                    <Row>
                      <Form.Group as={Col} md={12}>
                        <div className="form-inline">
                          <Form.Label>
                            <b>Observações</b>
                          </Form.Label>
                        </div>
                        <div className="form-inline">
                          <Form.Label>{dadosContribuinte?.observacao}</Form.Label>
                        </div>
                      </Form.Group>
                    </Row>
                  </div>
                </div>
              </Form.Group>
            </Row>
          </div>
        </Row>
      </div>
    </div>
  </div>
);

export default DadosGeraisCard;
